/* LuxGentleman: scroll infinito nativo per collection e ricerca (sostituisce l'app Scroller Pro).
   Quando la paginazione di Dawn entra in vista, carica la pagina successiva con la Section Rendering API
   e accoda i prodotti. Si riattiva da solo quando i filtri di Dawn ridisegnano la griglia. */
(function () {
  var busy = false, io = null;

  function nextLink(wrapper) {
    var cur = parseInt(wrapper.dataset.page || '1', 10);
    var links = wrapper.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var u = new URL(links[i].href, location.href);
      if (parseInt(u.searchParams.get('page') || '0', 10) === cur + 1) return u;
    }
    return null;
  }

  function setup() {
    var grid = document.getElementById('product-grid');
    var wrapper = document.querySelector('#ProductGridContainer .pagination-wrapper, .template-search .pagination-wrapper');
    if (!grid || !wrapper || wrapper.dataset.lgInf) return;   // già attivo su questa paginazione
    if (io) { io.disconnect(); io = null; }
    wrapper.dataset.lgInf = '1';
    wrapper.classList.add('lg-inf');
    var next = nextLink(wrapper);
    if (!next) { wrapper.classList.add('lg-inf--done'); return; }
    var loader = document.createElement('div');
    loader.className = 'lg-inf__loader';
    loader.innerHTML = '<span></span><span></span><span></span>';
    wrapper.appendChild(loader);
    io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) load(grid, wrapper, next);
    }, { rootMargin: '900px 0px' });
    io.observe(wrapper);
  }

  function load(grid, wrapper, next) {
    if (busy) return;
    busy = true;
    wrapper.classList.add('is-loading');
    var url = new URL(next.href);
    if (grid.dataset.id) url.searchParams.set('section_id', grid.dataset.id);
    fetch(url.toString())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid > li');
        items.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
        var newWrapper = doc.querySelector('.pagination-wrapper');
        if (io) { io.disconnect(); io = null; }
        if (newWrapper && items.length) {
          wrapper.replaceWith(document.importNode(newWrapper, true));
        } else {
          wrapper.classList.add('lg-inf--done');
          wrapper.classList.remove('is-loading');
        }
        busy = false;
        setup();
      })
      .catch(function () { busy = false; wrapper.classList.remove('is-loading'); wrapper.classList.add('lg-inf--fallback'); });
  }

  document.addEventListener('DOMContentLoaded', setup);
  if (document.readyState !== 'loading') setup();
  // i filtri di Dawn sostituiscono il contenuto di #ProductGridContainer: si riparte
  new MutationObserver(function () { if (!busy) setup(); })
    .observe(document.body, { childList: true, subtree: true });
})();

/* LuxGentleman (30/10/2026): filtro taglia = solo taglie disponibili ora.
   Il filtro taglia di Shopify mostra anche i prodotti in cui quella taglia è già venduta.
   Abbinato a "disponibile" (filter.v.availability=1) Shopify controlla la stessa variante:
   quindi quando c'è un filtro taglia lo aggiungiamo noi, e lo togliamo se lo avevamo messo noi. */
(function () {
  var KEY = 'lgAvAuto';
  function get() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function set(v) { try { v ? sessionStorage.setItem(KEY, '1') : sessionStorage.removeItem(KEY); } catch (e) {} }
  function fix(qs) {
    var p = new URLSearchParams(qs), size = false, av = p.has('filter.v.availability');
    p.forEach(function (v, k) { if (k.indexOf('filter.v.option.') === 0) size = true; });
    if (size && !av) { p.append('filter.v.availability', '1'); set(true); return p.toString(); }
    if (!size && av && get()) { p.delete('filter.v.availability'); set(false); return p.toString(); }
    return null;
  }
  var f = fix(location.search.slice(1));
  if (f !== null) { location.replace(location.pathname + (f ? '?' + f : '') + location.hash); return; }
  function hook() {
    if (!window.FacetFiltersForm || FacetFiltersForm.lgAv) return;
    var orig = FacetFiltersForm.renderPage;
    FacetFiltersForm.renderPage = function (searchParams, event, updateURLHash) {
      var s = fix(searchParams || '');
      return orig.call(this, s !== null ? s : searchParams, event, updateURLHash);
    };
    FacetFiltersForm.lgAv = true;
  }
  hook();
  document.addEventListener('DOMContentLoaded', hook);
})();
